import { borderRadius, color, shadow, ThemeColors } from '@evrekadev/evreka-ui-components'
import { Flex } from 'components'
import { OTPInput, REGEXP_ONLY_DIGITS } from 'input-otp'
import React, { PropsWithChildren } from 'react'
import styled, { keyframes } from 'styled-components'

export const OTP: React.FC<{
  onChange: (value: string) => void
  value?: string
  onComplete?: () => void
  disabled?: boolean
}> = ({ onChange, value, onComplete, disabled }) => {
  return (
    <OTPInput
      disabled={disabled}
      value={value}
      onChange={onChange}
      inputMode="numeric"
      pattern={REGEXP_ONLY_DIGITS}
      maxLength={6}
      onComplete={onComplete}
      render={({ slots }) => (
        <Flex middle="zero" gap={1}>
          <Flex gap={0.5}>
            {slots.slice(0, 3).map((slot, idx) => (
              <CharInput
                key={idx}
                isActive={slot.isActive}
                hasFakeCaret={slot.hasFakeCaret}
                disabled={disabled}
              >
                {slot.char}
              </CharInput>
            ))}
          </Flex>
          <div
            style={{
              height: '1px',
              width: '1rem',
              backgroundColor: ThemeColors.grey300,
            }}
          />
          <Flex gap={0.5}>
            {slots.slice(3).map((slot, idx) => (
              <CharInput
                key={idx}
                isActive={slot.isActive}
                hasFakeCaret={slot.hasFakeCaret}
                disabled={disabled}
              >
                {slot.char}
              </CharInput>
            ))}
          </Flex>
        </Flex>
      )}
    />
  )
}

const CharInput: React.FC<
  PropsWithChildren<{ isActive: boolean; hasFakeCaret: boolean; disabled?: boolean }>
> = ({ isActive, hasFakeCaret, disabled, children }) => {
  return (
    <InputStyled isActive={isActive} disabled={disabled}>
      {children}
      {hasFakeCaret && <FakeCaret />}
    </InputStyled>
  )
}

const InputStyled = styled.div<{
  isActive: boolean
  disabled?: boolean
}>`
  ${borderRadius(8)}
  ${shadow('xs')}
    height: 48px;
  width: 48px;
  border: 1px solid ${({ isActive }) => color(isActive ? 'green500' : 'grey300')};
  background-color: ${({ disabled }) => color(disabled ? 'grey50' : 'white')};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.1s ease-in-out;
  position: relative;
`

const caretBlink = keyframes`
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
  `

const CaretContainer = styled.div`
  position: absolute;
  pointer-events: none;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${caretBlink} 1s infinite;
`

const Caret = styled.div`
  width: 1px;
  height: 1.5rem;
  background-color: ${color('grey800')};
`

const FakeCaret: React.FC = () => (
  <CaretContainer>
    <Caret />
  </CaretContainer>
)
